import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { GenesysCloudPlatformApiService } from '../../../common/services/genesys-cloud-platform-api.service';
import { ConversationResponse } from '../models/conversation-response.models';
import { PaginationResponse } from '../../../common/models/pagination-response.model';
import { CommunicationType } from '../models/communication-type.enum';
import { ConnectionState } from 'common/store/genesys-cloud/conversations/common/models/connection-state.enum';
import { WrapUpCode } from 'common/store/genesys-cloud/conversations/common/models/wrap-up-code.model';

export type GetConversationsResponse = PaginationResponse<ConversationResponse>;

export abstract class ConversationApiBase {
  static readonly ConversationsPath = 'api/v2/conversations';
  static readonly UploadPath = 'uploads/postino-attachments';

  protected constructor(protected readonly api: GenesysCloudPlatformApiService, private readonly communicationTypePathSegment: string) {
  }

  getConversations$(communicationType: CommunicationType): Observable<ConversationResponse[]> {
    return this.api.get$<GetConversationsResponse>(ConversationApiBase.ConversationsPath, {
      params: {
        communicationType
      }
    }).pipe(
      map(response => response.entities)
    );
  }

  acceptConversation$(conversationId: string, participantId: string): Observable<void> {
    return this.changeConnectionState$(conversationId, participantId, ConnectionState.Connected);
  }

  closeConversation$(conversationId: string, participantId: string): Observable<void> {
    return this.changeConnectionState$(conversationId, participantId, ConnectionState.Disconnected);
  }

  getWrapUpCodes$(conversationId: string, participantId: string): Observable<WrapUpCode[]> {
    const path = `${ConversationApiBase.ConversationsPath}/${this.communicationTypePathSegment}/${conversationId}/participants/${participantId}/wrapupcodes`;
    return this.api.get$<WrapUpCode[]>(path);
  }

  wrapUpConversation$(conversationId: string, participantId: string, communicationId: string, wrapupCodeId: string): Observable<void> {
    const path = `${ConversationApiBase.ConversationsPath}/${this.communicationTypePathSegment}/${conversationId}/participants/${participantId}/communications/${communicationId}/wrapup`;
    const body = {
      code: wrapupCodeId
    };
    return this.api.post$<void>(path, body);
  }

  skipWrapUpForConversation$(conversationId: string, participantId: string): Observable<void> {
    const path = `${ConversationApiBase.ConversationsPath}/${this.communicationTypePathSegment}/${conversationId}/participants/${participantId}`;
    const body = { wrapupSkipped:  true };
    return this.api.patch$<void>(path, body);
  }

  private changeConnectionState$(conversationId: string, participantId: string, connectionState: ConnectionState): Observable<void> {
    const path = `${ConversationApiBase.ConversationsPath}/${this.communicationTypePathSegment}/${conversationId}/participants/${participantId}`;
    const body = { state:  connectionState };
    return this.api.patch$<void>(path, body);
  }
}
